/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityPrivacySignalsResult } from './MonitEntityPrivacySignalsResult';
import {
    MonitEntityPrivacySignalsResultFromJSON,
    MonitEntityPrivacySignalsResultFromJSONTyped,
    MonitEntityPrivacySignalsResultToJSON,
} from './MonitEntityPrivacySignalsResult';

/**
 * 
 * @export
 * @interface MonitPaginatedEntityPrivacySignalsResponse
 */
export interface MonitPaginatedEntityPrivacySignalsResponse {
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityPrivacySignalsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityPrivacySignalsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitPaginatedEntityPrivacySignalsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<MonitEntityPrivacySignalsResult>}
     * @memberof MonitPaginatedEntityPrivacySignalsResponse
     */
    results?: Array<MonitEntityPrivacySignalsResult>;
}

/**
 * Check if a given object implements the MonitPaginatedEntityPrivacySignalsResponse interface.
 */
export function instanceOfMonitPaginatedEntityPrivacySignalsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitPaginatedEntityPrivacySignalsResponseFromJSON(json: any): MonitPaginatedEntityPrivacySignalsResponse {
    return MonitPaginatedEntityPrivacySignalsResponseFromJSONTyped(json, false);
}

export function MonitPaginatedEntityPrivacySignalsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitPaginatedEntityPrivacySignalsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(MonitEntityPrivacySignalsResultFromJSON)),
    };
}

export function MonitPaginatedEntityPrivacySignalsResponseToJSON(value?: MonitPaginatedEntityPrivacySignalsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(MonitEntityPrivacySignalsResultToJSON)),
    };
}

